import PropTypes from 'prop-types';
import styles from './Product.module.css';
import { generateThumbnail } from '../../../Helpers/ThumbHelper';
import icon from './assets/icon.svg';

export default function Product({
    id,
    specifier,
    focus = 500,
    size = "256",
    title,
    description,
    onSelect,
    isActive = false,
    series,
    name = '',
    color = ''
}) {
    return (
        <li 
            className={`${styles.product} ${isActive ? styles.active : ''}`} 
            data-id={id} 
            onClick={() => onSelect(id)}
        >
            <div className={styles.imgWrapper}>
                <img 
                    loading='lazy' 
                    src={generateThumbnail(id, specifier, size, focus, series, name, color)} 
                    alt={`${title} - ${description}`} 
                />
                             <div className={styles.activeContent}>
                        <img src={icon} className={styles.selectedImg} width="96" height="69" alt="product thumbnail"/>
                    </div>
            </div>
            <div className={styles.productInfo}>
                <div className={styles.title}>{title}</div>
                <div className={styles.description}>{description}</div>
            </div>
        </li>
    );
}

Product.propTypes = {
    id: PropTypes.number.isRequired,
    specifier: PropTypes.string.isRequired,
    focus: PropTypes.number,
    size: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    series: PropTypes.string.isRequired,
    name: PropTypes.string,
    color: PropTypes.string,
};